import React, { useCallback, useMemo } from 'react';
import { CustomCellRendererProps } from '@ag-grid-community/react';
import {
  CellClickedEvent,
  Column,
  ICellRendererParams
} from '@ag-grid-community/core';
import { PivotCell } from 'src/pivot/PivotCell';
import { style } from 'typestyle';
import AgPivot from '../AgPivot';
import { CHILDREN_HIDDEN, IS_LEAF, IS_PARENT } from 'src/utils/interface/PivotCell.tags';
import classNames from 'classnames';

export type MfpOnRowExpandClicked = Pick<CellClickedEvent<PivotCell[]>, 'column' | 'data'>

const styles = style({
  $nest: {
    'i': {
      padding: '3px 10px 3px 10px',
      cursor: 'pointer',
      $nest: {
        [`&.${IS_LEAF}`]: {
          visibility: 'hidden'
        },
        [`&.${CHILDREN_HIDDEN}.${IS_PARENT}`]:{
          rotate: '90deg'
        }
      }
    }
  }

});

export interface MfpRowGroupCellRendererParams extends Required<CustomCellRendererProps<PivotCell[]>> {
  onToggleRowGroup: (params: MfpOnRowExpandClicked) => void,
}
const baseArrowClassNames = ['far','fa-solid', 'fa-fw']
export const MfpRowGroupCellRenderer = (params: MfpRowGroupCellRendererParams) => {
  const handleToggleRowGroup = useCallback(() => params.onToggleRowGroup(params), [params]);

  const arrowState = useMemo(() => {
    const arrowStateClasses:string[] = [];
    const cellClasses = AgPivot.getRowGroupCellClass(params);

    const leafOrParent = cellClasses.includes(IS_LEAF) ? IS_LEAF : IS_PARENT;
    arrowStateClasses.push(leafOrParent);

    if(cellClasses.includes(CHILDREN_HIDDEN)){
      arrowStateClasses.push('fa-angle-right')
    } else {
      arrowStateClasses.push('fa-angle-down')
    }
    return arrowStateClasses;
  }, [params]);

  const arrowClassName = classNames(baseArrowClassNames.concat(arrowState))

  return <div className={styles} onDoubleClick={handleToggleRowGroup}>
    <i onClick={handleToggleRowGroup} className={arrowClassName}></i>{params.valueFormatted}</div>
}
